<div class="cookie-banner" *ngIf="!cookiesAccepted">
  <div class="cookie-content">
    <div class="cookie-text">
      <p [innerHTML]="'cookie:warning' | translate"></p>
    </div>
    <div class="cookie-actions">
      <button class="btn btn-primary" (click)="acceptCookies()">
        {{ 'cookie:warning:accept' | translate }}
      </button>
    </div>
  </div>
</div>